const routes = {
  DEFAULT: "/",
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  MATCHDETAIL: "/dashboard/match/:matchId",
  FANCYSESSIONDETAIL: "/dashboard/match/:matchId/fancy/:fancyId",
  SUPERADMINLIST: '/admin-details/super-admin',
  ADMINLIST: '/admin-details/admin',
  MINIADMINLIST: '/admin-details/mini-admin',
  MASTERLIST: '/admin-details/master',
  SUPERLIST: '/admin-details/super',
  SUPERMASTERLIST: '/admin-details/super-master',
  AGENTLIST: '/admin-details/agent',
  CLIENTLIST: '/admin-details/client',
  CREATEUSER: '/admin-details/create/:userType',
  UPDATELIMIT: '/admin-details/update-limit/:userType',
  EDITUSER: '/admin-details/edit/:userId',
  STATEMENT: '/admin-details/statement/:userId',
  ACCOUNTOPERATIONS: '/admin-details/account-operations/:userId',
  LOGINREPORT: '/admin-details/login-report/:userId',
  // Reports section routes
  REPORTS_LOGIN_REPORT: '/reports/login-report',
  REPORTS_SECURE_CODE: '/reports/secure-code-report',
  // Settings routes
  SETTING: '/settings/setting',
  SEARCH_USER: '/settings/search-user',
  ADMIN_ACCOUNT_STATEMENT: '/settings/account-statement',
  CLIENT_ACCOUNT_OPERATIONS: '/settings/account-operations',
  TOSSBETS: '/sports-betting/toss-bets/:matchId/:matchName',
};

export default routes;
